import React, { Component } from 'react'
import { connect } from 'react-redux'
import { refreshTokenSSO } from '../redux/actions/auth'
import { LoadingScreen } from '../components/ui'
import { Redirect } from 'react-router-dom'
import { BaseToast } from '../components/ui/tools/Toast'
import { linkStorageID } from '../utils/variables'
import { validateLinkID } from '../utils/functions/checkFunctions'
import log from 'loglevel'

class SSOResponse extends Component {
  /**
   * Reads from url params to get authentication token, accountID, and user/supervisorID
   * @returns redirect to application if all params are found, if not then redirects to login
   */

  constructor (props) {
    super(props)
    this.state = { error: false }
  }

  async validationFailure () {
    await BaseToast('error',
      'Error validating email',
      'Your login is missing some information. Please check your settings and try again. If this issue continues contact Learnsafe Support.')

    this.props.history.push({
      pathname: '/'
    })
  }

  async componentDidMount () {
    if (this.props.location && this.props.location.search) {
      const params = new URLSearchParams(this.props.location.search)
      const token = params.get('token')
      const accountID = params.get('accountid')
      const supervisorID = params.get('supervisorid')
      const userName = params.get('username')

      if (!token || !accountID || !supervisorID || !userName) {
        log.error('params not found on auth object')
        await this.validationFailure()
      } else {
        this.props.refreshTokenSSO(token, supervisorID, accountID, userName)
          .catch(() => {
            BaseToast('error',
              'Error validating email',
              'Your login is missing some information. Please check your settings and try again. If this issue continues contact Learnsafe Support.')
              .then(() => {
                this.props.history.push({
                  pathname: '/'
                })
              })
          })
      }
    }
  }

  render () {
    if (this.props.isAuthenticated) {
      let redirectPath = '/'
      const linkID = window.localStorage.getItem(linkStorageID)
      if (linkID && validateLinkID(linkID)) { redirectPath = `/link/${linkID}` }

      return <Redirect to={redirectPath} />
    } else if (this.state.error) {
      return (
        <h2>There was an unknown error.</h2>
      )
    } else {
      return (
        <LoadingScreen />
      )
    }
  }
}

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated
})

// Hooking up to Redux store
export default connect(mapStateToProps, { refreshTokenSSO })(SSOResponse)
